import { render, staticRenderFns } from "./leftNav-text.vue?vue&type=template&id=5f64b96f&scoped=true"
import script from "./leftNav-text.vue?vue&type=script&lang=js"
export * from "./leftNav-text.vue?vue&type=script&lang=js"
import style0 from "./leftNav-text.vue?vue&type=style&index=0&id=5f64b96f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f64b96f",
  null
  
)

export default component.exports